import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min'
import { selectIsAuth } from '@store/profile.reducer'
import AuthPlaceholder from './AuthPlaceholder'
import s from './LayoutAuth.module.css'
import Logo from './Logo/Logo'
import classNames from 'classnames'
import Translation from '@common/Header/components/Translation/Translation'

const LayoutAuth = ({ children }) => {
  const isAuth = useSelector(selectIsAuth)

  if (isAuth) return <Redirect to='/' />

  return <div className={s.body}>
    <div className={s.wrapper}>
      <div className={classNames(s.part, s.left)}>
        <div className={s.headLeft}></div>
        <div className={s.bodyPartLeft}><AuthPlaceholder /></div>
      </div>
      <div className={classNames(s.part, s.right)}>
        <div className={s.headRight}><Logo /></div>
        <div className={s.wrapperTranslation}><Translation /></div>
        <div className={s.bodyPartRight}>{children}</div>
      </div>
    </div>

  </div>
}

export default LayoutAuth
